import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { AgencyFee } from "../Entities/AgencyFee/AgencyFee";
import { AgencyFeeInterface } from "../Entities/AgencyFee/AgencyFeeInterface";
import Store from "../../Store/Store";
import CurrencyContainer from "../../Currency/CurrencyContainer";

class AgencyFeeFactory extends Factory implements FactoryInterface {

  public create(data: any): AgencyFeeInterface {
    return new AgencyFee({
      id: data.id,
      agencyId: data.agencyId,
      companyId: data.companyId,
      objectType: data.objectType,
      objectId: data.objectId,
      currency: CurrencyContainer.pickFromId(data.currency),
      fixedFee: data.fixedFee,
      finalAmount: data.finalAmount,
      percentageFee: data.percentageFee,
      fixedPlusPercentageMode: Store.getConfigurator().getState().globalTypes?.FixedPlusPercentageModes?.[data.fixedPlusPercentageMode],
      removed: data.removed,
      vat: data.vat,
      firstDate: data.firstDate === null ? null : new Date(data.firstDate),
      lastDate: data.lastDate === null ? null : new Date(data.lastDate),
      chargeTypeIds: data.chargeTypeIds,
      repeatPeriod: data.repeatPeriodId,
      assignmentServiceStatus: data.serviceStatusId,
      statusId: data.statusId,
      date: data.date === null ? null : new Date(data.date),
    });
  }

  public reinitialize(data: any): AgencyFeeInterface {
    return new AgencyFee({
      ...data
    });
  }
}

export default new AgencyFeeFactory();
